import CaptivateImageGridThree from './CaptivateImageGridThree';
import CaptivateImageGridTwo from './CaptivateImageGridTwo';

const CaptivateImageGridFive = ({
  dataList = [],
  variation = 1,
  updateCarouselState = imageNo => {},
}) => {
  return (
    <>
      <CaptivateImageGridThree
        dataList={dataList.slice(0, 3)}
        variation={variation}
        updateCarouselState={updateCarouselState}
      />
      <CaptivateImageGridTwo
        dataList={dataList.slice(3)}
        variation={variation}
        updateCarouselState={updateCarouselState}
      />
    </>
  );
};

export default CaptivateImageGridFive;
